<!--
 * @Description: 协定服务问卷详情
 * @Date: 2025-04-11 18:44:27
-->
<template>
  <div>
    <BaseDescriptions
      v-for="(topic, index) in questionInfo"
      :key="index"
      :title="getTitle(topic)"
      :column="1"
      size="large"
      direction="vertical"
    >
      <BaseDescriptionsItem
        v-if="topic.remark"
        :label="`备注：${topic.remark}`"
      ></BaseDescriptionsItem>
      <!-- 上传pdf/上传word/上传excel/上传ppt -->
      <template>
        <BaseDescriptionsItem
          :key="value + index"
          v-for="(value, index) in topic.values"
        >
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <BaseToolTip
              placement="top"
              effect="dark"
              :content="value.name"
              :disabled="value.name < 22"
            >
              <BaseButton
                :disabled="!value.url"
                @click="onViewer(value.url)"
                type="text"
              >
                {{
                  value.name.length > 22
                    ? value.name.slice(0, 22) + '...'
                    : value.name
                }}
              </BaseButton>
            </BaseToolTip>

            <span>【{{ value.uploadSource || uploadSource }}】</span>
          </div>
        </BaseDescriptionsItem>
      </template>
    </BaseDescriptions>
  </div>
</template>
<script lang="tsx" setup>
import { computed } from 'vue';
import {
  BaseButton,
  BaseDescriptions,
  BaseDescriptionsItem,
  BaseToolTip
} from 'xrk-components';
import { FILE_VIEW_URL } from '@/config';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';

const store = useProjectDetailStore();

withDefaults(
  defineProps<{
    questionInfo: any;
  }>(),
  {
    questionInfo: () => ({})
  }
);
const emits = defineEmits(['changeImgUrl']);

//协定服务上传来源1ASP上传2C端上传3双方共同上传
const agreementServiceUploadType = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadType;
});

//协定服务上传方式1以活动方式上传2以人为维度上传
const agreementServiceUploadMode = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadMode;
});
const isEntry = [
  +agreementServiceUploadMode.value,
  +agreementServiceUploadType.value
].join(',');
// '1,3': '活动形式-双方共同上传',
// '1,1': '活动形式-服务商上传',
// '2,2': '人为维度-终端上传',
// '2,1': '人为维度-服务商上传',

const uploadSource = computed(() => {
  switch (isEntry) {
    case '1,3':
      return '终端上传';
    case '1,1':
      return '终端上传';
    case '2,2':
      return '终端上传';
    case '2,1':
      return '服务商上传';
    default:
      return '';
  }
});

const getTitle = topic => {
  return topic.label;
};

//文件预览
const onViewer = url => {
  const imageTypeReg = new RegExp(/\.bmp|\.jpg|\.png|\.gif|\.jpeg/, 'i');
  if (imageTypeReg.test(url)) {
    emits('changeImgUrl', url);
    return;
  }
  window.open(`${FILE_VIEW_URL}?t=${Date.now()}&url=${url}`);
};
</script>
<style lang="scss" scoped></style>
